import { Injectable } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { Paciente } from 'app/core/interfaces/pacient-info.interface';
import { Observable } from 'rxjs';
import { Enfermeiro } from 'app/core/interfaces/enfermeiro.interface';
import { PreviousRouteService } from 'app/shared/previous-route.service';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { Secretaria } from 'app/core/interfaces/secretaria.interface';
import { Pagination } from 'app/core/interfaces/pagination.interface';
import { Organizacao } from 'app/core/interfaces/organizacao.interface';


@Injectable({
  providedIn: 'root'
})
export class EnfermeiroService {

  usuario: any;
  organizacao: Organizacao;
  navigation: any;
  
  constructor(
    private authService: AuthService,
    private _apigestacard: APIGestaCardService,
    private previousRouteService: PreviousRouteService

  ) { }

  GetPreviousUrl() {
    return this.previousRouteService.getPreviousUrl();
  }

  GetUserData(): Observable<any> {
    return Observable.create((observer) => {
      this.authService.LerComoObs().subscribe((res) => {
        this.usuario = res;
        observer.next(res);
      });
    });
  }

  GetOrgData(): Observable<Organizacao> {
    return Observable.create((observer) => {
      this.authService.LerOrgComoObs().subscribe((res) => {
        this.organizacao = res;
        observer.next(res);
      });
    });
  }


  GetOrganizacao() {
    return this._apigestacard.PegarOrganizacaoLogada();
  }

  GetInfoEnfermeiro(id: string) {
    return this._apigestacard.PegarUmEnfermeiroPorId(id);
  }

  GetConsultas() {
    return this._apigestacard.ListaConsultasEnfermeiro(this.usuario.email);
  }

  GetConsultaPorCartao(id_cartao: string) {
    return this._apigestacard.ListaConsultasPorCartao(id_cartao);
  }

  GetListaMedicos() {
    return this._apigestacard.PegarListaMedicos();
  }

  GetListaEnfermeiros() {
    return this._apigestacard.PegarListaEnfermeiros();
  }

  GetListaSecretarias() {
    return this._apigestacard.PegarListaSecretarias();
  }

  AtualizarPerfilEnfermeiro(enfermeiro: Enfermeiro): Promise<any> {
    return this._apigestacard.AtualizarEnfermeiro(enfermeiro);
  }

  AtualizarSenha(senha_atual: string, nova_senha: string): Promise<any> {
    return this.authService.UpdatePassword(this.usuario.email, senha_atual, nova_senha);
  }

  AlterarEmailPaciente(pacienteId, email) {
    return this;
  }

  GetListaEmailsMedicos(): Observable<any> {
    return Observable.create((observer) => {
      this.GetListaMedicos().subscribe((medicos) => {
        const medicosResumidos = medicos.map((item: any) => {
          const obj = {
            email: item.email,
            nome: `${item.primeiro_nome} ${item.sobrenome}`
          };
          return obj;
        });
        observer.next(medicosResumidos);
        observer.complete();
      });
    });
  }

  GetListaEmailsEnfermeiros(): Observable<any> {
    return Observable.create((observer) => {
      this.GetListaEnfermeiros().subscribe((enfermeiros) => {
        const enfermeirosResumidos = enfermeiros.map((item: any) => {
          const obj = {
            email: item.email,
            nome: `${item.primeiro_nome} ${item.sobrenome}`
          };
          return obj;
        });
        observer.next(enfermeirosResumidos);
        observer.complete();
      });
    });
  }

  TotalCartoesUsadosPeloEnfermeiro(id_enfermeiro: string): Promise<any> {
    return this._apigestacard.TotalCartoesUsadosPorEnfermeiro(id_enfermeiro);
  }

  /** CRUD SECRETARIAS */
  CadastrarSecretaria(secretaria: Secretaria): Promise<any> {
    return this.authService.CreateSecretary(secretaria);
  }

  EmailResetSecretaria(email_secretaria) {
    return this.authService.EnviarEmailRecuperacaoDeSenha(email_secretaria);
  }

  DeletarSecretaria(secretaria: Secretaria): Promise<any> {
    return this._apigestacard.DeletarSecretaria(secretaria);
  }

  AtualizarSecretaria(secretaria: Secretaria): Promise<any> {
    return this._apigestacard.AtualizarSecretaria(secretaria);
  }

  GetSecretariaPorId(id: string): Promise<Secretaria> {
    return this._apigestacard.PegarSecretariaPorId(id);
  }

  BloquearSecretaria(secretaria: Secretaria): Promise<Secretaria> {
    secretaria.bloqueado = true;

    return this._apigestacard.AtualizarSecretaria(secretaria);
  }

  DesbloquearSecretaria(secretaria: Secretaria): Promise<Secretaria> {
    secretaria.bloqueado = false;

    return this._apigestacard.AtualizarSecretaria(secretaria);
  }

  /** CRUD PACIENTES */
  CadastrarPaciente(paciente): Promise<any> {
    return this.authService.CreatePacient(paciente);
  }

  EmailResetPaciente(email_paciente) {
    return this.authService.EnviarEmailRecuperacaoDeSenha(email_paciente);
  }

  AtualizarPaciente(paciente: Paciente): Promise<any> {
    return this._apigestacard.AtualizarPaciente(paciente);
  }

  DeletarPaciente(email_paciente: string, id?: string): Promise<any> {
    return this._apigestacard.DeletarPaciente(email_paciente, id);
  }

  GetListaPaciente(enfermeiroId: string) {
    return this._apigestacard.PegarListaPacientesDeUmEnfermeiro(enfermeiroId);
  }

  GetListaPacientePage(page: number = 1, limit: number = 12, search: object = {}): Observable<Pagination<Paciente>> {
    return this._apigestacard.PegarListaPacientesDeUmEnfermeiroPage(page, limit, search);
  }

  GetPacientePorEmail(email_paciente: string, id?: string): Promise<Paciente> {
    return this._apigestacard.PegarPacientePorEmail(email_paciente, id);
  }

  GetPacientePorId(id: string): Promise<Paciente> {
    return this._apigestacard.PegarPacientePorIdCompletasso(id);
  }

  GetPacientePorIdObs(id: string): Observable<Paciente> {
    return Observable.create((observer) => {
      this._apigestacard.PegarPacientePorIdCompletasso(id).then((res) => {
        observer.next(res);
        observer.complete();
      }).catch((err) => {
        observer.error(err);
      });
    });
  }


  AdicionarCartaoAoPaciente(email_paciente: string) {
    return this._apigestacard.AdicionarCartaoAPaciente(email_paciente, undefined, this.usuario.id);
  }

  LerCartaoAtivoPaciente(email_paciente: string): Promise<any> {
    return this._apigestacard.LerOCartaoAtivo(email_paciente);
  }

  LerUltimoCartao(email_paciente: string): Promise<any> {
    return this._apigestacard.LerUltimoCartao(email_paciente);
  }

  LerUmCartao(cartao_id: string) {
    return this._apigestacard.LerUmCartaoGestante(cartao_id);
  }

  AtivarUmCartao(enfermeiro_id: string, paciente_id: string, id_cartao: string) {
    return this._apigestacard.AtivarUmCartaoPeloEnfermeiro(enfermeiro_id, paciente_id, id_cartao);
  }

  RegistrarEncerramento(id_cartao: string, encerramentoObj: object) {
    return this._apigestacard.RegistrarEncerramento(id_cartao, encerramentoObj);
  }

  DesativarUmCartao(id_cartao: string) {
    return this._apigestacard.DesativarUmCartao(id_cartao);
  }

  AtualizarCartao(cartao_id: string, cartao_atualizado: any) {
    return this._apigestacard.AtualizarCartao(cartao_id, cartao_atualizado);
  }

  DeletarCartaoGestante(cartao_id: string) {
    return this._apigestacard.DeletarCartao(cartao_id);
  }

  GetSomenteUmEnfermeiro(email: string): Promise<any> {
    return this._apigestacard.PegarUmEnfermeiroPorEmail(email);
  }

  MudarStatusArquivo(arquivo_id: string, status: 'pendente' | 'processado' | 'utilizado'): Promise<any> {
    return this._apigestacard.MudarStatusArquivo(arquivo_id, status);
  }

  CriarConsulta(dados_consulta: any, email_enfermeiro: string, email_paciente: string, id_cartao: string): Promise<any> {
    return this._apigestacard.CriarConsulta(email_paciente, email_enfermeiro, id_cartao, dados_consulta);
    // var consulta: ConsultaPaciente = {
    //   date: data, 
    //   id_enfermeiro: email_enfermeiro, 
    //   id_paciente: email_paciente
    // };
    // return this._apigestacard.CriarNovaConsulta(consulta, consulta.id_enfermeiro, consulta.id_paciente); 
  }

  AtualizarConsulta(dados_consulta: any, consulta_id: string): Promise<any> {
    return this._apigestacard.AlterarConsulta(consulta_id, dados_consulta);
  }

  ExcluirConsulta(consulta_id: string): Promise<any> {
    return this._apigestacard.DeletarConsulta(consulta_id);
  }

  ListarConsultasEnfermeiro(email_enfermeiro: string): Promise<any> {
    return this._apigestacard.ListaConsultasEnfermeiro(email_enfermeiro);
  }

  CriarWebviewCartaoGestante(enfermeiro: Enfermeiro, paciente: Paciente): Promise<string> {
    return this._apigestacard.CriarWebviewCartaoGestante(enfermeiro, paciente);
  }
}
